var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.displayAdminInfos.length !== 0)?_c('AdminInformationDialog',{key:_vm.currentDisplayAdminInfo.id,attrs:{"info":_vm.currentDisplayAdminInfo},on:{"close":_vm.handleCloseAndOpenNextAdminInfo}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }